import React from "react";
import { DataGrid } from '@mui/x-data-grid';

function Loader() {
  return (
    <div className="row w-100 justify-content-center text-center prevent-select">
      <div className='loader'></div>
    </div>
  );
}

function DataGridWrapper(props) {
  return (
    <DataGrid
      rows={props.tableData}
      columns={props.columns}
      getRowHeight={() => { return 'auto' }}
      disableRowSelectionOnClick
  />
  );
}

export { Loader, DataGridWrapper };
